export const FORM_ALREADY_SUBMITTED_MESSAGE = 'This form has already been submitted.';
export const FORM_JUST_SUBMITTED_MESSAGE = 'Your form has been submitted successfully. Thank you.';
